import * as React from "react";
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';

const Menu = ({ type, actions = [], open, toggleState, direction = 'down', onActionClickhandler }) => {
  return (
    <SpeedDial
      ariaLabel='menu for header'
      icon={type}
      open={open}
      sx={{
        "& .MuiSpeedDial-fab": {
          backgroundColor: "#F7931A",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#F7931A",
            color: "#FFFFFF",
          },
        },
      }}
      direction={direction}
      position='absolute'
      onClick={toggleState}
      //onClose={close}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={() => onActionClickhandler(action)}
        />
      ))}
    </SpeedDial>
  );
};

export default Menu;

